import React from "react";
import {
  Paper,
  Grid2 as Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  useTheme,
} from "@mui/material";
import { FilterOptions } from "./types";
import { DatePicker } from "@mui/x-date-pickers";

const FilterSection: React.FC<{
  filters: FilterOptions;
  handleDateChange: (
    field: keyof FilterOptions
  ) => (newValue: Date | null) => void;
  handleSortChange: (event: SelectChangeEvent) => void;
}> = ({
  filters,
  handleDateChange,
  handleSortChange,
}) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mx: 2,
        mb: 2,
        bgcolor: theme.palette.grey[50],
        borderRadius: 1,
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid size={{xs:12, sm:6, md: 3}}>
          <DatePicker
            label="Från datum"
            value={filters.startDate}
            onChange={handleDateChange("startDate")}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
        <Grid size={{xs:12, sm:6, md: 3}}>
          <DatePicker
            label="Till datum"
            value={filters.endDate}
            onChange={handleDateChange("endDate")}
            slotProps={{ textField: { fullWidth: true, size: "small" } }}
          />
        </Grid>
       
        <Grid size={{xs:12, sm:6, md: 3}}>
          <FormControl fullWidth size="small">
            <InputLabel>Sortera efter</InputLabel>
            <Select
              value={filters.sortBy}
              onChange={handleSortChange}
              label="Sortera efter"
            >
              <MenuItem value="newest">Nyast först</MenuItem>
              <MenuItem value="oldest">Äldst först</MenuItem>
              <MenuItem value="value-high">Högst värde först</MenuItem>
              <MenuItem value="value-low">Lägst värde först</MenuItem>
              <MenuItem value="probability-high">
                Högst sannolikhet först
              </MenuItem>
              <MenuItem value="probability-low">
                Lägst sannolikhet först
              </MenuItem>
              <MenuItem value="name-asc">Namn (A-Ö)</MenuItem>
              <MenuItem value="name-desc">Namn (Ö-A)</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FilterSection;
